import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Despertar de la Atención',
    desc: 'El punto de partida del método. Actividades diseñadas con el sistema 3C: Calma, Conexión, Logro para reactivar la capacidad de atención real de tu hijo desde el primer día.',
    bullets: ['Plan de acción días 1 al 7', 'Actividades de concentración progresiva', 'Rutina de desconexión nocturna', 'Calendario de 21 días', 'Diploma de logro + tabla de seguimiento', 'Guía completa para padres']
  }, {
    icon: '📗',
    title: 'Tomo 2 — Creatividad al Límite',
    desc: 'Transformá su adicción a los videos en creatividad genuina. Actividades de arte, diseño y expresión que reemplazan el estímulo digital con asombro y producción real.',
    bullets: ['Dibujo paso a paso y puntillismo', 'Diseño de personaje propio', 'Mapas mentales e historietas', 'Mandalas y arquitectura creativa', 'Libro ilustrado final', 'Diploma + calendario de creatividad']
  }, {
    icon: '📙',
    title: 'Tomo 3 — Desafíos Numéricos',
    desc: 'Matemática, lógica y cálculo mental presentados como misiones y desafíos. Para que tu hijo descubra que pensar puede ser más adictivo que cualquier pantalla.',
    bullets: ['Cálculo mental tipo "agente secreto"', 'Sudoku, patrones y Fibonacci', 'Cuadrados mágicos y geometría', 'Problemas cotidianos reales', 'Torneo matemático final', 'Diploma + tabla de seguimiento']
  }, {
    icon: '📕',
    title: 'Tomo 4 — Mundo de Palabras',
    desc: 'Lectura, vocabulario y escritura creativa que despiertan el amor por el lenguaje. Para que tu hijo descubra que las palabras pueden construir mundos más emocionantes que cualquier video.',
    bullets: ['Cazador de palabras y lectura veloz', 'Historia que nunca termina', 'Periodista junior y poeta sin reglas', 'Debates y diccionario visual', 'Cartas y retos de lenguaje', 'Diploma + guía para padres']
  }, {
    icon: '📓',
    title: 'Tomo 5 — Laboratorio de Emociones',
    desc: 'La guía para que tu hijo entienda, nombre y regule lo que siente. Porque un niño que conoce sus emociones no necesita una pantalla para evadirlas.',
    bullets: ['Mapa de emociones personalizado', 'Actividades de regulación emocional', 'Juegos de empatía y conexión', 'Técnicas de calma express', 'Diario emocional guiado', 'Diploma + tabla de progreso']
  }, {
    icon: '📔',
    title: 'Tomo 6 — El Maestro del Tiempo',
    desc: 'Tu centro de mando familiar. Rutinas visuales, sistema de hábitos y el plan de 90 días para que la mente enfocada sea permanente y no dure solo una semana.',
    bullets: ['Rutinas visuales listas para imprimir', 'Sistema de recompensas sin pantallas', 'Plan de 90 días semana a semana', 'Gestión del tiempo propia para el niño', 'Cuadros de seguimiento y logros', 'Diploma final del Método completo']
  }];
  const features = ['Actividades listas para usar (sin preparación previa)', 'Clasificación por edad: 4-6 / 7-9 / 10-12 años', 'Materiales accesibles (kiosco o supermercado)', 'Fichas imprimibles y reutilizables', 'Lenguaje directo para padres, sin jerga psicológica', '100% alineado al desarrollo cognitivo infantil'];
  return <section className="bg-dark-900 py-12 px-4" data-id="element-217">
      <div className="max-w-6xl mx-auto" data-id="element-218">
        <div className="text-center mb-10" data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-bold text-cream mb-3" data-id="element-220">
            🏆 MÉTODO MENTE ENFOCADA™
          </h2>
          <p className="text-lg md:text-xl text-primary font-semibold mb-1" data-id="element-221">
            6 Tomos + 6 Bonos — Niños de 4 a 12 años
          </p>
          <p className="text-base md:text-lg text-cream/70" data-id="element-222">
            300+ páginas — Todo resuelto. Listo para usar hoy.
          </p>
        </div>

        <h3 className="text-xl md:text-2xl font-bold text-cream mb-6 text-center" data-id="element-223">
          📦 6 TOMOS COMPLETOS
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-224">
          {tomos.map((tomo, idx) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} key={idx} className="bg-dark-800 rounded-2xl p-6 border border-primary/30 hover:border-primary transition-colors" data-id="element-225">
              <div className="flex items-start mb-3" data-id="element-226">
                <span className="text-4xl mr-3" data-id="element-227">{tomo.icon}</span>
                <h4 className="text-lg md:text-xl font-bold text-cream" data-id="element-228">
                  {tomo.title}
                </h4>
              </div>
              <p className="text-cream/80 mb-4 text-sm md:text-base" data-id="element-229">
                {tomo.desc}
              </p>
              <div className="bg-dark-900 rounded-xl p-4" data-id="element-230">
                <p className="font-semibold text-primary mb-3" data-id="element-231">✅ Incluye:</p>
                <ul className="space-y-2" data-id="element-232">
                  {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start text-sm text-cream/90" data-id="element-233">
                      <CheckCircle2 className="w-4 h-4 text-primary mr-2 shrink-0 mt-0.5" data-id="element-234" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary-dark rounded-3xl p-6 md:p-10 border border-primary/40" data-id="element-235">
          <h4 className="text-xl md:text-2xl font-bold text-cream mb-6 text-center" data-id="element-236">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-237">
            {features.map((feature, i) => <div key={i} className="flex items-center text-cream/90" data-id="element-238">
                <span className="text-cta mr-3 text-xl" data-id="element-239">✅</span>
                {feature}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}